import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSlideOut20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowSlideOut20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M7.729 3.7a6.3 6.3 0 0 1 4.56 2.312l-1.064 1.07a4.809 4.809 0 1 0-3.82 7.726 4.8 4.8 0 0 0 3.805-1.873l1.07 1.063a6.3 6.3 0 0 1-4.876 2.31L7.08 16.3a6.31 6.31 0 0 1-5.975-5.976L1.096 10a6.31 6.31 0 0 1 6.308-6.309zm7.525 3.621a.75.75 0 0 1 1.06 0l2.112 2.11.558.56-2.67 2.67a.75.75 0 0 1-1.06-1.061l.864-.865H10.75a.75.75 0 0 1 0-1.5h5.358l-.854-.853a.75.75 0 0 1 0-1.06"
            />
        </svg>
    );
}
export default memo(IconArrowSlideOut20);
